// Dev/checkout page: given ?paymentOrderId, build the BORICA intent and POST the
// signed form to the gateway. Seed a payable PaymentOrder first via
// `POST /api/dev/payments/checkout-scenario` (see ops/http/borica-checkout.http).

import { GatewayFormPost, useCreatePaymentIntent } from '@podium/platform/payments'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'

export const Route = createFileRoute('/checkout/')({
  validateSearch: (search: Record<string, unknown>) => ({
    paymentOrderId: typeof search.paymentOrderId === 'string' ? search.paymentOrderId : '',
  }),
  component: CheckoutPage,
})

function CheckoutPage() {
  const { paymentOrderId } = Route.useSearch()
  const intent = useCreatePaymentIntent()

  useEffect(() => {
    if (!paymentOrderId) return
    // Only send a returnUrl on https origins — the allowlist (and the BORICA
    // spec) rejects http. On http://localhost the intent omits it; settlement
    // still completes and the browser lands on the fallback page. To exercise
    // the SPA bounce locally, serve the frontend on an allowlisted https host.
    const origin = typeof window === 'undefined' ? '' : window.location.origin
    const returnUrl = origin.startsWith('https') ? `${origin}/checkout/return` : undefined
    intent.mutate({ orderId: paymentOrderId, request: returnUrl ? { returnUrl } : {} })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentOrderId])

  if (!paymentOrderId) return <p>Missing ?paymentOrderId — seed one via /api/dev/payments/checkout-scenario.</p>
  if (intent.isPending || intent.isIdle) return <p>Preparing payment…</p>
  if (intent.isError) return <p>Could not start payment: {String(intent.error)}</p>

  const result = intent.data
  if (result?.type === 'GatewayFormPost') return <GatewayFormPost intent={result} />
  return <p>Unsupported payment intent type: {result?.type ?? 'unknown'}</p>
}
